/**
 * @file Enumerator used to describe the sort direction of a SortDescriptor.
 * @author Tom Verschoore de la Houssaije
 */
export var SortDirection;
(function (SortDirection) {
    /** None meaning no sorting  */
    SortDirection[SortDirection["None"] = 0] = "None";
    /** Use to sort descending */
    SortDirection[SortDirection["Descending"] = 1] = "Descending";
    /** Use to sort ascending */
    SortDirection[SortDirection["Ascending"] = 2] = "Ascending";
})(SortDirection || (SortDirection = {}));
